import { useAppConfig } from "hooks/queries";
import { useAppSelector } from "hooks/redux";
import React from "react";
import { selectAppConfig } from "store/appConfigSlice";

const Loading = () => {
  const appConfig = useAppSelector(selectAppConfig);
  
  return (
    <div id="loaderOverlay" className="loaderOverlay">
      <nav id="mainNav" className="navbar navbar-expand-lg navbar-light bg-white justify-content-between shadow-sm">
	<div>
	<a className="navbar-brand d-flex align-items-center mb-0 pt-0" href="/">
		{appConfig?.logo && <img className='logo k-mr-2' src={`data:image/png;base64,${appConfig?.logo}`} alt="application unison"/>}

    {!appConfig?.logo &&  <img src="/image/logoUnison.svg" alt="Unison logo" className="logo k-mr-2"   /> }
		<div className="appName">RFI Assistant</div>
	</a>
		
	</div>
	<div id="navbarNavMain" className="d-lg-block">
		
	</div>
</nav>
      <div className="loaderWrapper">
        <div className="ballGridPulse">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="loaderCustomMessage">
          Please wait...
          <br />
          Data is loading
        </div>
      </div>
    </div>
  );
};

export default Loading;
